
import React, { Component } from 'react';
import PAService from '../services/PASevice';
import UserPointTransactionService from '../services/UserPointTransactionService';
import MessageComponent from '../template/Message';
import ApiService from '../services/apiService';
import Logo from './../assets/images/logo.png';
import { Dialog } from 'primereact/dialog';
import SecondaryPackingService from '../services/SecondaryPackingService';

export default class DiProduct extends Component {

    constructor(props) {
        super(props);

        this.PAService = new PAService();
        this.ApiService = new ApiService();
        this.UserPointTransactionService = new UserPointTransactionService();
        this.SecondaryPackingService = new SecondaryPackingService();

        this.state = {
            visible: false,
            DIDDetails: [],
            verifyProduct: {}
        };

        this.hideFunc = this.hideFunc.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {

        const DID = window.location.href;

        setTimeout(() => {
            this.GetDIDDetails(DID);
        }, 1000);
    }

    handleClick(event) {
        console.log("Carton clicked");
    }

    openDialog() {
        this.setState({
            visible: true,
            formHeading: "Product Details"
        });
    }

    GetDIDDetails(DID) {

        this.SecondaryPackingService.GetDIDDetails(DID).then(data => {

            const resdata = data.data.ResponseData;

            if (resdata !== null) {

                this.setState({
                    DIDDetails: resdata,
                    verifyProduct: resdata[0] || {}
                });

            } else {

                this.setState({
                    DIDDetails: []
                });

            }
        });
    }

    hideFunc() {

        this.setState({
            visible: false,
            buttonLabel: 'Submit',
            formHeading: 'Feedback'
        });

    }

    render() {

        return (

            <div>

                <MessageComponent />

                <div className="container p-0">

                 <div className="text-center mb-3">
    <img
        src={Logo}
        alt="Company Logo"
        style={{ maxHeight: "80px" }}
    />
</div>

                    <div className="d-flex justify-content-around align-content-around flex-wrap"
                        style={{
                            width: "95%",
                            border: "2px solid #c3dce4",
                            margin: "30px auto",
                            borderRadius: "10px",
                            padding: "15px"
                        }}>

                        {this.state.DIDDetails && this.state.DIDDetails.map((item, index) => (

                            <div key={index} className="col-md-6 mb-3 d-flex justify-content-center p-2">

                                <div className="card bg-card" style={{ width: "100%" }}>

                                    <div className="card-header row mx-1">

                                        <div className="card-text">

                                            <div className="col-md-12">

                                                <div className="row">

                                                    {item.DeliveryNo &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Delivery No</div>
                                                            <div className="col-md-7 text-muted">{item.DeliveryNo}</div>
                                                        </div>
                                                    }

                                                    {item.DeliveryDate &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Delivery Date</div>
                                                            <div className="col-md-7 text-muted">{item.DeliveryDate}</div>
                                                        </div>
                                                    }

                                                    {item.ShipToParty &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Ship To Party</div>
                                                            <div className="col-md-7 text-muted">{item.ShipToParty}</div>
                                                        </div>
                                                    }

                                                    {item.ShipToPartyName &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Ship To Party Name</div>
                                                            <div className="col-md-7 text-muted">{item.ShipToPartyName}</div>
                                                        </div>
                                                    }

                                                    {item.TerminalDispatchId &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Terminal Dispatch Id</div>
                                                            <div className="col-md-7 text-muted">{item.TerminalDispatchId}</div>
                                                        </div>
                                                    }

                                                    {item.CartonId &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Carton Id</div>
                                                            <div className="col-md-7 text-muted">

                                                                {item.TerminalDispatchId ? (
                                                                    <a
                                                                        href={`di-details?${item.CartonId}`}
                                                                        onClick={this.handleClick}
                                                                    >
                                                                        {item.CartonId}
                                                                    </a>
                                                                ) : (
                                                                    item.CartonId
                                                                )}

                                                            </div>
                                                        </div>
                                                    }

                                                    {item.ProductName &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Product Name</div>
                                                            <div className="col-md-7 text-muted">{item.ProductName}</div>
                                                        </div>
                                                    }

                                                    {item.ProductCode &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Product Code</div>
                                                            <div className="col-md-7 text-muted">{item.ProductCode}</div>
                                                        </div>
                                                    }

                                                    {item.ProductDscrptn &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Chemical Name</div>
                                                            <div className="col-md-7 text-muted">{item.ProductDscrptn}</div>
                                                        </div>
                                                    }

                                                    {item.BatchNo &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Batch No</div>
                                                            <div className="col-md-7 text-muted">{item.BatchNo}</div>
                                                        </div>
                                                    }

                                                    {item.Plant &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Plant</div>
                                                            <div className="col-md-7 text-muted">{item.Plant}</div>
                                                        </div>
                                                    }

                                                    {item.Qty &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Pack of Quantity</div>
                                                            <div className="col-md-7 text-muted">{item.Qty}</div>
                                                        </div>
                                                    }

                                                    {item.ManufactureDate &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Manufacture Date</div>
                                                            <div className="col-md-7 text-muted">{item.ManufactureDate}</div>
                                                        </div>
                                                    }

                                                    {item.ExpiryDate &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Expiry Date</div>
                                                            <div className="col-md-7 text-muted">{item.ExpiryDate}</div>
                                                        </div>
                                                    }

                                                    {/* {item.CreatedDt &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Created Date</div>
                                                            <div className="col-md-7 text-muted">{item.CreatedDt}</div>
                                                        </div>
                                                    } */}

                                                    {item.Remarks &&
                                                        <div className="col-md-12 border-bottom p-2">
                                                            <div className="col-md-5 text-bold">Sale For</div>
                                                            <div className="col-md-7 text-muted">{item.Remarks}</div>
                                                        </div>
                                                    }

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                    <Dialog
                        className="popup-modal"
                        header="All Product"
                        visible={this.state.visible}
                        modal={true}
                        onHide={this.hideFunc}
                    >
                        <div className="m-5">

                            <div className="text-center">
                                Product Details Popup
                            </div>

                        </div>
                    </Dialog>

                </div>

            </div>

        );
    }
}

